import { createRouter, createWebHistory } from 'vue-router';
import Home from '@/views/Home.vue';
import About from '@/views/AboutUs.vue';
import GalleryList from '@/views/GalleryList.vue';
import GalleryDetail from '@/views/GalleryDetail.vue';
import HistoryList from '@/views/HistoryList.vue';
import HistoryDetail from '@/views/HistoryDetail.vue';
import Slide from '@/views/Slide.vue';

const routes = [
  { path: '/', component: Home, meta: { title: 'Home' } },
  { path: '/about', component: About, meta: { title: 'About Us' } },
  { path: '/gallery', component: GalleryList, meta: { title: 'Album' } },
  { path: "/gallery/:folder", name: "GalleryDetail", component: GalleryDetail, props: (route) => ({ albumKey: route.params.folder }),},
  { path: '/history', component: HistoryList, meta: { title: 'Diary' } },
  { path: '/history/:post_id', name: 'HistoryDetail', component: HistoryDetail, meta: { title: 'Diary' }, props: (route) => ({ post_id: Number(route.params.post_id) }) },
  { path: '/slide', component: Slide, meta: { title: 'Project' } }
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  // scrollBehavior(to, from, savedPosition) {
  //   // ページ遷移時にスクロール位置をリセット
  //   if (savedPosition) {
  //     return savedPosition; // 戻るボタンなどの場合に以前の位置へ
  //   } else {
  //     return { top: 0 }; // デフォルトでページトップへ
  //   }
  // },
});

export default router;